<template>
	<nk-wrapper v-if="context.ort && context.ort.titel" spacing="md">
		<nk-accordion
			:title="context.titel || 'Kontaktdaten'"
			title-size="xl"
			:open="options.openAccordion || false"
		>
			<nk-row>
				<nk-col cols="shrink" class="hidden sm:block">
					<nk-icon
						icon="map"
						size="2xl"
						:inline="false"
						:background-color="true"
						color="neutral"
						variant="boxed"
					/>
				</nk-col>
				<nk-col cols="auto">
					<nk-link
						v-if="
							typeof context.ort.rubriken !== 'undefined' &&
							!options.noAddressTitleLink &&
							context.ort.rubriken.length > 0 &&
							context.ort.rubriken[0].detailURL !== $route.path
						"
						:link="context.ort.rubriken[0].detailURL"
					>
						<nk-title v-if="context.ort.titel" size="lg" color="type-dark">
							{{ context.ort.titel }}
						</nk-title>
					</nk-link>
					<template v-else-if="context.ort.titel">
						<nk-title size="lg">
							{{ context.ort.titel }}
						</nk-title>
					</template>
					<nk-row vertical-gutter="2">
						<nk-col cols="full" sm="6/12">
							<nk-title size="md">Ansprechpartner</nk-title>
							<nk-address
								variant="vertical"
								v-bind="context.ort.kontakt"
								:ansprechpartner="context.ort.ansprechpartner"
							/>
						</nk-col>
						<nk-col
							v-if="context.ort.adresse.zeige_adresse"
							cols="full"
							sm="6/12"
						>
							<nk-title size="md">Adresse</nk-title>
							<nk-address variant="vertical" v-bind="context.ort.adresse" />
						</nk-col>
					</nk-row>
				</nk-col>
			</nk-row>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
/**
 * @prop {string} context.titel
 * @prop {object} context.ort
 * @prop {boolean} options.openAccordion
 * @prop {boolean} options.noAddressTitleLink
 */
export default {
	name: 'NkTemplateOrt',

	mixins: [TemplatesDefault],
};
</script>
